import React from "react";
import "./servitoragreement.css";
import Navbar from "../../Components/Navbar";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const ServitorAgreement = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <Navbar />

      <div className="agreement-page">
        <div className="agreement-container">
          <div className="agreement-card">
            <header className="agreement-header">
              <h1 className="agreement-title">
                {t("servitor_agreement.title")}
              </h1>
              <hr />
              <p className="agreement-subtitle">
                {t("servitor_agreement.subtitle")}
              </p>
              <p className="agreement-updated">
                {t("servitor_agreement.last_updated")}
              </p>
            </header>

            <p className="agreement-intro-note">
              {t("servitor_agreement.read_note")}
            </p>

            {/* 1. Parties */}
            <section className="agreement-section">
              <h2>{t("servitor_agreement.sections.parties.title")}</h2>
              <p>{t("servitor_agreement.sections.parties.body")}</p>
            </section>

            {/* 2. Nature of Work */}
            <section className="agreement-section">
              <h2>{t("servitor_agreement.sections.nature_of_work.title")}</h2>
              <p>{t("servitor_agreement.sections.nature_of_work.body")}</p>
            </section>

            {/* 3. Responsibilities & Liability */}
            <section className="agreement-section">
              <h2>{t("servitor_agreement.sections.responsibilities.title")}</h2>
              <ul>
                <li>
                  {t(
                    "servitor_agreement.sections.responsibilities.items.professional"
                  )}
                </li>
                <li>
                  {t(
                    "servitor_agreement.sections.responsibilities.items.liability"
                  )}
                </li>
                <li>
                  {t(
                    "servitor_agreement.sections.responsibilities.items.safety"
                  )}
                </li>
                <li>
                  {t(
                    "servitor_agreement.sections.responsibilities.items.no_extra_charge"
                  )}
                </li>
              </ul>
            </section>

            {/* 4. Earnings & Fees */}
            <section className="agreement-section">
              <h2>{t("servitor_agreement.sections.earnings.title")}</h2>
              <ul>
                <li>
                  {t(
                    "servitor_agreement.sections.earnings.items.after_completion"
                  )}
                </li>
                <li>
                  {t(
                    "servitor_agreement.sections.earnings.items.platform_fee"
                  )}
                </li>
                <li>
                  {t(
                    "servitor_agreement.sections.earnings.items.promo_credit"
                  )}
                </li>

                <li>{t("servitor_agreement.sections.earnings.items.policy_updates")}</li>

              </ul>
            </section>

            {/* 5. Job Completion & Cancellation */}
            <section className="agreement-section">
              <h2>{t("servitor_agreement.sections.job_completion.title")}</h2>
              <ul>
                <li>
                  {t(
                    "servitor_agreement.sections.job_completion.items.unjust_cancel"
                  )}
                </li>
                <li>
                  {t(
                    "servitor_agreement.sections.job_completion.items.payment_on_completion"
                  )}
                </li>
                <li>
                  {t(
                    "servitor_agreement.sections.job_completion.items.dispute_investigation"
                  )}
                </li>
              </ul>
            </section>

            {/* 6. Misconduct & Fraud */}
            <section className="agreement-section">
              <h2>{t("servitor_agreement.sections.misconduct.title")}</h2>
              <p>{t("servitor_agreement.sections.misconduct.body")}</p>
              <ul>
                <li>
                  {t(
                    "servitor_agreement.sections.misconduct.items.fraud_scamming"
                  )}
                </li>
                <li>
                  {t(
                    "servitor_agreement.sections.misconduct.items.unethical_behavior"
                  )}
                </li>
                <li>
                  {t(
                    "servitor_agreement.sections.misconduct.items.harassment"
                  )}
                </li>
                <li>
                  {t(
                    "servitor_agreement.sections.misconduct.items.repeated_cancel"
                  )}
                </li>
                <li>
                  {t(
                    "servitor_agreement.sections.misconduct.items.low_rating"
                  )}
                </li>
              </ul>
            </section>

            {/* 7. Privacy Requirements */}
            <section className="agreement-section">
              <h2>{t("servitor_agreement.sections.privacy.title")}</h2>
              <ul>
                <li>
                  {t(
                    "servitor_agreement.sections.privacy.items.no_share_number"
                  )}
                </li>
                <li>
                  {t(
                    "servitor_agreement.sections.privacy.items.no_save_media"
                  )}
                </li>
                <li>
                  {t(
                    "servitor_agreement.sections.privacy.items.data_usage"
                  )}
                </li>
                <li>
                  {t(
                    "servitor_agreement.sections.privacy.items.no_sell_data"
                  )}
                </li>
              </ul>
            </section>

            {/* 8. Termination */}
            <section className="agreement-section">
              <h2>{t("servitor_agreement.sections.termination.title")}</h2>
              <p>{t("servitor_agreement.sections.termination.body")}</p>
              <ul>
                <li>
                  {t(
                    "servitor_agreement.sections.termination.items.misconduct_verified"
                  )}
                </li>
                <li>
                  {t(
                    "servitor_agreement.sections.termination.items.user_complaints_true"
                  )}
                </li>
                <li>
                  {t(
                    "servitor_agreement.sections.termination.items.damage_confirmed"
                  )}
                </li>
                <li>
                  {t(
                    "servitor_agreement.sections.termination.items.suspicious_activity"
                  )}
                </li>
              </ul>
            </section>

            <footer className="agreement-footer">
              <p>{t("servitor_agreement.footer_text")}</p>
            </footer>
            
          </div>

          {/* Back Button Row */}
          <div className="agreement-back-row">
            <button
              type="button"
              className="agreement-back-button"
              onClick={() => navigate(-1)}
            >
              <span className="agreement-back-icon" aria-hidden="true">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15 19L8 12L15 5"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              <span className="agreement-back-text">
                {t("servitor_agreement.back")}
              </span>
            </button>
          </div>
          
        </div>
      </div>
    </>
  );
};

export default ServitorAgreement;
